import { useEffect, useState } from 'react';

import { ISkillsQueryVariables } from 'graphql/types';
import { DEFAULT_PAGINATION_SETTINGS } from 'common/hooks/usePagination';

interface IProps {
    paginationVariables?: {
        offset: number;
        first: number;
    };
    searchQueryParam?: string;
}

export const useSkillQueryVariables = ({
    paginationVariables,
    searchQueryParam,
}: IProps) => {
    const [skillQueryVariables, setSkillQueryVariables] =
        useState<ISkillsQueryVariables>({
            q: '',
            ...DEFAULT_PAGINATION_SETTINGS,
        });

    useEffect(() => {
        const newSkillQueryVariables = {
            ...paginationVariables,
            q: searchQueryParam,
        };

        const { q, offset, first } = skillQueryVariables;

        if (
            q === newSkillQueryVariables.q &&
            offset === newSkillQueryVariables.offset &&
            first === newSkillQueryVariables.first
        ) {
            return;
        }

        setSkillQueryVariables({
            ...skillQueryVariables,
            ...newSkillQueryVariables,
            offset:
                q !== newSkillQueryVariables.q
                    ? 0
                    : newSkillQueryVariables.offset,
        });
    }, [skillQueryVariables, paginationVariables, searchQueryParam]);

    return { skillQueryVariables };
};
